import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faClose,
} from '@fortawesome/pro-regular-svg-icons';

import { Accordion } from '@client/components/Accordion';
import { Button } from '@client/components/common/inputs/Button';
import { moveArray } from '@client/components/landing-page-builder/helpers';
import { TextField } from '@client/new/components/basic';
import { UseFormRegisterReturn } from 'react-hook-form';
import { ArrayItem } from '../../helpers/types';
import { FaqsSectionSchema } from '@client/pages/CustomProgramPage/OTPLandingPage.schema';

type FAQ = ArrayItem<FaqsSectionSchema['faqs']>;
type Props = {
  value: FaqsSectionSchema;
  onChange: (value: FaqsSectionSchema) => void;
  register: (name: string) => UseFormRegisterReturn;
};
export const FAQs = ({ value, onChange, register: r }: Props) => {
  const onFaqsChange = (faqs: FAQ[]) => onChange({ ...value, faqs });
  const faqs: FAQ[] = (value.faqs as FAQ[]) || [];

  const remove = (i: number) => {
    const next: FAQ[] = [...faqs.slice(0, i), ...faqs.slice(i + 1)];
    onFaqsChange(next);
  };

  const move = (from: number, to: number) => {
    onFaqsChange(moveArray<FAQ>(value.faqs as FAQ[], from, to));
  };

  const defaultPreviewText = 'Add your question here...';

  return (
    <div>
      {faqs.map((x, i) => {
        return (
          <div
            key={i}
            className="flex space-x-0 mb-4 items-start flex-col sm:flex-row sm:space-x-3"
          >
            <div className="w-[39px] h-[39px] shrink-0 rounded-lg text-lg flex items-center justify-center bg-[#E1E5F0] mb-3 sm:mb-0">
              {i + 1}
            </div>
            <Accordion
              hasError={false}
              title={x.question || defaultPreviewText}
              customizations={null}
              isPlaceholder={!x.question}
            >
              <div className="relative">
                <div className="">
                  <TextField
                    className="w-full"
                    {...r(`faqs.${i}.question`)}
                    inputProps={{
                      maxLength: 60,
                      placeholder: defaultPreviewText,
                      className: `w-full`,
                    }}
                  />
                </div>
              </div>
              <div className="relative mt-3 bg-white">
                <TextField
                  className="w-full"
                  {...r(`faqs.${i}.answer`)}
                  multiline
                  rows={3}
                  inputProps={{
                    placeholder: 'Answer',
                    maxLength: 700,
                    className: 'resize-none',
                  }}
                />
              </div>
            </Accordion>

            <div className="flex items-center h-[39px] pl-[28px]">
              <div className="w-[40px]">
                {i > 0 && faqs.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faChevronUp}
                    onClick={() => move(i, i - 1)}
                    className="-mb-0.5 cursor-pointer"
                  />
                ) : null}
              </div>
              <div className="w-[40px]">
                {i < faqs.length - 1 && faqs.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    onClick={() => move(i, i + 1)}
                    className="cursor-pointer"
                  />
                ) : null}
              </div>
              <div className="w-[40px]">
                {faqs.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faClose}
                    onClick={() => remove(i)}
                    className="cursor-pointer"
                  />
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
      <Button
        onClick={() => onFaqsChange([...faqs, { question: '', answer: '' }])}
      >
        Add FAQ
      </Button>
    </div>
  );
};
